// src/pages/AgentDetailPage.tsx
//
// Reforma UX §6.6 + §10 item 2: o detalhe de agente deixou de ser página e
// virou MODAL sobre a lista (AgentDetailModal). A rota /agents/:id é mantida
// como DEEP-LINK: este wrapper renderiza a AgentsPage com o modal já aberto
// pro agente da URL (fechar o modal navega de volta pra /agents).

import { useParams } from 'react-router-dom';
import { AgentsPage } from './AgentsPage';

export function AgentDetailPage() {
  const { id } = useParams<{ id: string }>();
  return <AgentsPage detailRef={id} />;
}
